import { isLogin } from 'utils/token'
import Main from './Main'

const VerificationAlertOffers = ({ onVerify }) => {
  if (!isLogin()) return null
  return <Main onVerify={onVerify} />
}

export default VerificationAlertOffers
